<template>
  <b-modal
    id="add-job-site"
    ref="add-job-site"
    size="lg-size"
    hide-header
    hide-footer
    centered
    @shown="onModalShown"
    @hide="onModalHide"
  >
    <div class="modal-head">
      <h2 class="modal-title">
        {{label.get('add_job_site')}}
      </h2>
    </div>
    <div
      class="content-wrapper job-sites-wrapper"
      :class="{'error': hasError}"
    >
      <div class="job-fields atto-form">
        <div class="field-row">
          <div class="field-wrap">
            <label for="name">{{label.get('name')}}</label>
            <input
              id="name"
              v-model="name"
              type="text"
              name="name"
              maxlength="50"
              :placeholder="label.get('enter_job_site_name')"
            >
          </div>
        </div>
        <div class="field-row">
          <div class="field-wrap">
            <label>{{label.get('address')}}</label>
            <search-dropdown-component
              :value="address"
              :options="jobAddresses"
              :placeholder="label.get('enter_job_site_address')"
              @onOptionSelected="onAddressSelected"
              @onInputChange="onAddressSearch"
            />
          </div>
        </div>
        <div class="field-row">
          <div class="field-wrap">
            <label>{{label.get('diameter')}}</label>
            <select-dropdown-component
              :value="radius"
              :options="radiusOptions"
              @onOptionSelected="onRadiusSelected"
              :placeholder="label.get('select_radius')"
            />
          </div>
        </div>
      </div>
      <div class="job-site-map">
        <l-map
          v-if="visibleMap"
          :zoom="zoom"
          :center="center"
          :min-zoom="minZoom"
          :max-zoom="maxZoom"
          :bounds="markerBounds"
          :zoom-animation="true"
          :fade-animation="true"
          :marker-zoom-animation="true"
          :zoom-animation-threshold="10"
          class="map-container"
        >
          <l-tile-layer
            :url="url"
            :attribution="attribution"
          />
          <l-marker
            :lat-lng="getMarkerLatLng()"
            :icon="icon"
          />
        </l-map>
      </div>
      <div
        v-if="hasError"
        class="error-wrapper"
      >
        <span class="error-message">
          {{label.get('please_fill_the_blank_fields')}}
        </span>
      </div>
    </div>
    <div class="modal-footer">
      <button
        class="atto-btn cancel"
        @click="onModalHide"
      >
        {{label.get('cancel')}}
      </button>
      <button
        class="atto-btn submit"
        :disabled="saveChangesEnabled"
        @click="saveChanges"
      >
          {{label.get('add_job_site')}}
      </button>
    </div>
  </b-modal>
</template>

<script>
    import JobSitesService from '../services/JobSitesService';
    import SearchDropdownComponent from '../../../../shared/components/SearchDropdownComponent';
    import SelectDropdownComponent from '../../../../shared/components/SelectDropdownComponent';

    export default {
        name: "AddJobSiteComponent",
        components: {
            SearchDropdownComponent,
            SelectDropdownComponent
        },
        data() {
            return {
                maxZoom: 16,
                minZoom: 5,
                zoom: 13,
                center: [0.0, 0.0],
                bounds: null,
                url: 'https://{s}-tiles.locationiq.com/v2/obk/r/{z}/{x}/{y}.png?key=pk.b79bd6c735e4ccd1a09bace11fdbd698',
                attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
                icon: L.divIcon({
                    html: '<span class="inner-neutral"></span>',
                    iconSize: [60, 60]
                }),
                options: {
                    animate: true,
                    pan: {
                        duration: 10
                    }
                },
                hasError: false,
                visibleMap: false,
                selectedAddress: null,
                name: null,
                address: null,
                radius: "600",
                marker: {
                    latitude: 0,
                    longitude: 0
                },
                markerLatLang: [],
                jobAddresses: [],
                jobAddressesResults: [],
                radiusOptions: JobSitesService.radiusOptions(),
                saveChangesEnabled: false
            }
        },
        computed: {
            markerBounds: function () {
                return this.getBounds(this.marker);
            },
            filteredMarkers() {
                let markers = [];
                if (this.marker.latitude != null && this.marker.longitude != null) {
                    markers.push({
                        latitude: this.marker.latitude,
                        longitude: this.marker.longitude,
                    });
                }
                return markers;
            },

        },
        created() {
            this.getInitialCenter();
        },
        mounted() {
            document.body.appendChild(this.$el);
            this.$refs['add-job-site'].show();
        },
        methods: {
            onModalShown() {
                this.visibleMap = true;
            },
            onModalHide() {
                this.$root.$emit('hideNewJobSiteModal');
            },
            zoomUpdated(zoom) {
                this.zoom = zoom;
            },
            centerUpdated(center) {
                this.center = center;
            },
            boundsUpdated(bounds) {
                this.bounds = bounds;
            },
            getInitialCenter() {
                const x = localStorage.getItem('current_location');
                if (x !== null) {
                    const locationObj = JSON.parse(x);
                    this.center = [locationObj.latitude, locationObj.longitude];
                    this.marker = locationObj;
                } else {
                    const _this = this;
                    navigator.geolocation.getCurrentPosition(function (position) {
                        const centerLtLng = [position.coords.latitude, position.coords.longitude];
                        const myLatLng = {
                            latitude: position.coords.latitude,
                            longitude: position.coords.longitude
                        };
                        localStorage.setItem('current_location', JSON.stringify(myLatLng));
                        _this.marker = myLatLng;
                        _this.center = centerLtLng;
                    });
                }
            },
            getBounds() {
                let _this = this;
                let bounds = new L.LatLngBounds();
                bounds.extend(_this.getMarkerLatLng(this.marker));
                return bounds;
            },
            getMarkerLatLng() {
                return L.latLng(this.marker.latitude, this.marker.longitude);
            },
            centerMarker() {
                let _this = this;
                this.centerUpdated(L.latLng(this.marker.latitude + 0.001, this.marker.longitude));
                if (this.zoom < 16) {
                    setTimeout(function () {
                        _this.zoomUpdated(16);
                    }, 300);
                }
            },

            onAddressSelected(option) {
              this.address = option;
              this.selectedAddress = this.jobAddressesResults[option.value];
              this.marker.latitude = this.selectedAddress.lat;
              this.marker.longitude = this.selectedAddress.lng;
              /*this.filteredMarkers();*/
              this.centerMarker();
            },
            onAddressSearch(query) {
                const _this = this;
                if (query !== undefined && query !== '') {
                    if (_this.debounce) {
                        clearTimeout(_this.debounce);
                    }
                    _this.debounce = setTimeout(() => {
                        JobSitesService.searchLocations(query).then((result) => {
                            _this.jobAddressesResults = result;
                            _this.jobAddresses = result.map((item, idx) => {
                                return {
                                    value: idx,
                                    label: item.address.name
                                };
                            });
                        }).catch((error) => {
                        });
                    }, 800);
                } else {
                    _this.jobAddresses = [];
                    _this.jobAddressesResults = [];
                }
            },
            onRadiusSelected(option) {
              this.radius = option.value;
            },

            saveChanges() {
                if (this.name === null || this.address === null) {
                    this.hasError = true;
                    return false;
                }

                const data = {
                    name: this.name,
                    address: this.address.label,
                    location: this.marker.latitude + ',' + this.marker.longitude,
                    radius: this.radius
                };

                this.saveChangesEnabled = false;
                this.$store.commit('showLoading');
                JobSitesService.newFavoriteLocations(data).then((result) => {
                    this.$store.commit('hideLoading');
                    this.saveChangesEnabled = false;
                    this.$root.$emit('hideNewJobSiteModal', result.data);
                }).catch((error) => {
                    this.$store.commit('hideLoading');
                    this.saveChangesEnabled = true;
                    this.hasError = true;
                });
            }
        }
    }
</script>

<style lang="scss">
    .job-sites-wrapper {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        .error-wrapper{
            width: 100%;
        }
        > div:not(.error-wrapper){
            flex: 1;
        }

        .job-fields {
            display: flex;
            flex-direction: column;
            width: calc(50% - 24px);
            margin-right: 48px;

            .field-wrapper {

                display: flex;
                flex-direction: column;
            }

            .field-wrap{
                .search-filtering{
                    .select-heading{
                        span.selected{
                            white-space: nowrap;
                            overflow: hidden;
                            text-overflow: ellipsis;
                        }
                    }
                }
            }
        }

        &.error{
            padding-bottom: 0!important;
        }

    }

    .job-fields{
      .atto-select .select-heading span{
        color: $atto-font-color !important;
      }
    }

</style>
<style lang="scss" scoped>
  .modal .modal-head{
    padding: 40px 40px 16px;
  }
  .modal-lg-size .modal-content .modal-body .content-wrapper.job-sites-wrapper{
    padding: 8px 40px 24px 40px;
  }
  .modal .modal-footer{
    padding: 8px 40px 40px;
  }
</style>